module.exports = __webpack_public_path__ + "static/media/IMG_3355 1.843db0d2.jpg";